/** Where "Contact us" about Pro goes (the design leaves the owner open; Slack links to a sales contact). */
export const PRO_CONTACT_URL = "mailto:sales@bundle.direct?subject=Bundle%20Pro";
